module.exports = __webpack_public_path__ + "img/gongying2.2ab5ffb2.png";